export const API_URL: string = `https://www.yeastphotofestival.it/wp-json/progetty/v1`

export const BASEPATH: string = '/'
export const isTouchScreen = function isTouchDevice() {
    return 'ontouchstart' in window || navigator.maxTouchPoints > 0
}
